import React from 'react';
import Navbar from './Navbar.js';
import Footer from './footer.js';
import './Teacher.css';

const Teacher = () => {
  return (
    <div className="edu-patent-page">
      <Navbar />
      <main className="edu-patent-hero">
          <h1>Cnyda Dynamics Patents Division</h1>
        <section className="edu-patent-body">
          <h2 className="edu-patent-sub-heading">AI Teacher Patent:</h2>
          
          <div className="edu-patent-description">
            <p>
              Every citizen, regardless of their family’s educational heritage, should be granted the opportunity to learn from and be mentored by individuals of exceptional cognitive ability or an AI avatar modeled after such intellect, thereby fostering deep rationality and comprehensive knowledge from a formative age. We posit that the chronic lack of such high-caliber guidance is a fundamental driver of the cycle of under-achievement, increased susceptibility to crime, 
              and the entrenched socio-economic disadvantages that continue to plague children from lower-income backgrounds. By democratizing access to elite mentorship, we can effectively bridge the opportunity gap, equipping the next generation with the cognitive tools and analytical frameworks necessary to navigate and transcend their circumstances.
            </p>

            <img 
              src="https://images.unsplash.com/photo-1501504905252-473c47e087f8?q=80&w=2074&auto=format&fit=crop" 
              alt="Digital Learning Environment" 
              className="edu-patent-media"
            />

            <p>
              However, this proposal faces intense scrutiny and contention. Skeptics argue that shifting toward AI-driven or standardized elite mentorship could potentially erode the nuanced, human-centric nature of traditional pedagogy, which relies heavily on interpersonal empathy and lived experience. There is also the significant challenge of centralization: concerns arise regarding who defines 'exceptional cognitive ability' and who manages the ideological or intellectual parameters of such AI systems, raising fears of a monolithic or biased educational landscape. Furthermore, some theorists contend that focusing primarily on mentorship overlooks deeper, 
              structural issues—such as systemic resource inequality, food insecurity, and housing instability—that may render even the best guidance ineffective. The debate thus centers on whether intellectual empowerment alone can rectify generational disadvantage, or if it risks oversimplifying complex systemic failures by placing the entire burden of mobility on the individual’s cognitive development.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Teacher;